import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.access-shell {
  display: grid;
  width: 100%;
  min-height: 100%;
  grid-template-columns: minmax(480px, 1.08fr) minmax(500px, 0.92fr);
  overflow: hidden;
  background: #ffffff;
  color: #0b1019;
  font-family: "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

.access-visual {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  overflow: hidden;
  background: radial-gradient(circle at 75% 20%, rgba(38, 136, 255, 0.34), transparent 31%), radial-gradient(circle at 8% 92%, rgba(80, 52, 231, 0.24), transparent 32%), linear-gradient(145deg, #07162c 0%, #0b2c57 52%, #0a58b7 100%);
  padding: 46px clamp(44px, 6vw, 92px) 40px;
  color: #ffffff;
}

.access-visual-grid {
  position: absolute;
  inset: 0;
  opacity: 0.13;
  background-image: linear-gradient(rgba(255, 255, 255, 0.24) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.24) 1px, transparent 1px);
  background-size: 54px 54px;
  mask-image: linear-gradient(to bottom right, #000, transparent 80%);
}

.access-visual-orb {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 999px;
}

.access-visual-orb::before,
.access-visual-orb::after {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: inherit;
  content: "";
}

.access-visual-orb-one {
  top: -110px;
  right: -90px;
  width: 430px;
  height: 430px;
}

.access-visual-orb-one::before {
  inset: 54px;
}

.access-visual-orb-one::after {
  inset: 112px;
}

.access-visual-orb-two {
  bottom: -260px;
  left: 20%;
  width: 520px;
  height: 520px;
}

.access-visual-orb-two::before {
  inset: 60px;
}

.access-visual-orb-two::after {
  inset: 126px;
}

.access-brand,
.access-mobile-brand {
  position: relative;
  z-index: 2;
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 12px;
  color: #ffffff;
  text-decoration: none;
}

.access-brand-symbol {
  display: grid;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  grid-template-columns: repeat(2, 1fr);
  gap: 3px;
  border: 4px solid currentColor;
  border-radius: 11px;
  padding: 4px;
}

.access-brand-symbol i {
  display: block;
  border-radius: 3px;
  background: #77ded5;
}

.access-brand-symbol i:nth-child(2) {
  background: #c8ff62;
}

.access-brand-symbol i:nth-child(3) {
  background: #ffbc65;
}

.access-brand-symbol i:nth-child(4) {
  background: #7185f6;
}

.access-brand strong,
.access-brand small,
.access-mobile-brand strong,
.access-mobile-brand small {
  display: block;
}

.access-brand strong,
.access-mobile-brand strong {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.access-brand small,
.access-mobile-brand small {
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.68);
  font-family: "Inter Variable", Inter, sans-serif;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.access-visual-copy {
  position: relative;
  z-index: 2;
  width: min(650px, 100%);
  margin: auto 0;
}

.access-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  color: #74d7ff;
  font-family: "Inter Variable", Inter, sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.access-visual-copy h1 {
  margin: 22px 0 0;
  font-size: clamp(36px, 3.8vw, 58px);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.22;
}

.access-visual-copy > p:not(.access-eyebrow) {
  max-width: 590px;
  margin: 24px 0 0;
  color: rgba(226, 239, 255, 0.76);
  font-size: 16px;
  line-height: 1.8;
}

.access-capabilities {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 34px;
}

.access-capabilities span {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  padding: 0 14px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  font-weight: 650;
  backdrop-filter: blur(8px);
}

.access-visual-footer {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 9px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 12px;
}

.access-visual-footer strong {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.08em;
}

.access-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #70e6bf;
  box-shadow: 0 0 0 5px rgba(112, 230, 191, 0.12);
}

.access-panel {
  position: relative;
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  background: #ffffff;
  padding: 72px clamp(34px, 5vw, 88px) 36px;
}

.access-theme-button {
  position: absolute;
  top: 24px;
  right: 28px;
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 8px;
  border: 1px solid #e1e5eb;
  border-radius: 9px;
  background: #ffffff;
  padding: 0 12px;
  color: #586273;
  font-size: 12px;
  font-weight: 650;
}

.access-theme-button:hover {
  border-color: #b9c9e7;
  background: #f8faff;
  color: #1c4efc;
}

.access-mobile-brand {
  display: none;
}

.access-form-wrap {
  width: min(430px, 100%);
}

.access-form-header {
  margin-bottom: 28px;
}

.access-form-header h2,
.access-form-header p {
  margin: 0;
}

.access-form-kicker {
  color: #1c4efc !important;
  font-family: "Inter Variable", Inter, sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.access-form-header h2 {
  margin-top: 10px;
  color: #0b1019;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.access-form-header p:last-child {
  margin-top: 9px;
  color: #7b8494;
  font-size: 13px;
  line-height: 1.6;
}

.access-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  border-radius: 10px;
  background: #f0f2f6;
  padding: 4px;
}

.access-tab {
  min-height: 42px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #7c8696;
  font-size: 13px;
  font-weight: 700;
}

.access-tab.is-active {
  background: #ffffff;
  color: #172033;
  box-shadow: 0 3px 10px rgba(36, 45, 59, 0.08);
}

.access-form {
  display: grid;
  gap: 18px;
  margin-top: 24px;
}

.access-field {
  display: grid;
  gap: 7px;
}

.access-field > span {
  color: #3d4756;
  font-size: 13px;
  font-weight: 700;
}

.access-field > div {
  display: flex;
  min-height: 48px;
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe3ea;
  border-radius: 9px;
  background: #ffffff;
  padding: 0 13px;
  color: #9aa3b2;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.access-field > div:focus-within {
  border-color: #80a4ff;
  box-shadow: 0 0 0 3px rgba(28, 78, 252, 0.1);
  color: #1c4efc;
}

.access-field input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: #172033;
  font-size: 13px;
}

.access-field input::placeholder {
  color: #a1a9b6;
}

.access-submit {
  display: flex;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
  border: 0;
  border-radius: 9px;
  background: linear-gradient(120deg, #1c4efc, #086eea);
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(28, 78, 252, 0.18);
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.access-submit:hover:not(:disabled) {
  box-shadow: 0 15px 30px rgba(28, 78, 252, 0.28);
  transform: translateY(-1px);
}

.access-submit:disabled {
  cursor: wait;
  opacity: 0.58;
}

.access-switch {
  margin: 0;
  color: #7b8494;
  font-size: 12px;
  text-align: center;
}

.access-switch button {
  border: 0;
  background: transparent;
  padding: 0 0 0 5px;
  color: #1c4efc;
  font-weight: 800;
}

.access-form-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 14px;
  margin-top: 36px;
  color: #98a0ad;
  font-size: 12px;
}

.access-form-footer a {
  color: #70798a;
  text-decoration: none;
}

.access-form-footer a:hover {
  color: #1c4efc;
}

@media (max-width: 1080px) {
  .access-shell {
    grid-template-columns: minmax(400px, 0.9fr) minmax(470px, 1.1fr);
  }
  .access-visual {
    padding-right: 44px;
    padding-left: 44px;
  }
  .access-visual-copy h1 {
    font-size: 40px;
  }
}
@media (max-width: 860px) {
  .access-shell {
    display: block;
    overflow-y: auto;
  }
  .access-visual {
    display: none;
  }
  .access-panel {
    min-height: 100vh;
    align-items: flex-start;
    padding-top: 110px;
  }
  .access-mobile-brand {
    position: absolute;
    top: 28px;
    left: 28px;
    display: flex;
    color: #0b1019;
  }
  .access-mobile-brand .access-brand-symbol {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    border-width: 3px;
    border-color: #172033;
  }
  .access-mobile-brand strong {
    font-size: 13px;
  }
  .access-mobile-brand small {
    color: #7b8494;
  }
}
@media (max-width: 520px) {
  .access-panel {
    padding: 102px 22px 28px;
  }
  .access-theme-button {
    top: 27px;
    right: 20px;
    width: 38px;
    justify-content: center;
    padding: 0;
  }
  .access-theme-button span {
    display: none;
  }
  .access-mobile-brand {
    left: 20px;
  }
  .access-form-header h2 {
    font-size: 26px;
  }
}
:host-context(html[data-theme=dark]) .access-panel {
  background: #091524;
}

:host-context(html[data-theme=dark]) .access-form-header h2,
:host-context(html[data-theme=dark]) .access-field > span,
:host-context(html[data-theme=dark]) .access-field input,
:host-context(html[data-theme=dark]) .access-tab.is-active {
  color: #eef4ff;
}

:host-context(html[data-theme=dark]) .access-tabs {
  background: #111f32;
}

:host-context(html[data-theme=dark]) .access-tab.is-active,
:host-context(html[data-theme=dark]) .access-field > div,
:host-context(html[data-theme=dark]) .access-theme-button {
  border-color: #293b52;
  background: #101e31;
}

:host-context(html[data-theme=dark]) .access-theme-button,
:host-context(html[data-theme=dark]) .access-switch,
:host-context(html[data-theme=dark]) .access-form-header p:last-child {
  color: #97a6b9;
}

:host-context(html[data-theme=dark]) .access-mobile-brand {
  color: #ffffff;
}

:host-context(html[data-theme=dark]) .access-mobile-brand .access-brand-symbol {
  border-color: #ffffff;
}`],
})
export class PageAccessComponent implements OnInit {
    public theme: string = 'light';
    private themeStorageKey: string = 'nanofab.theme';

    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public loading: boolean = false;

    public data: any = {
        email: '',
        password: ''
    };

    public signup: any = {
        email: '',
        name: '',
        password: '',
        passwordConfirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        this.applyTheme(this.detectTheme());
        let check = await this.service.auth.check();
        if (check) return this.service.href("/dashboard2");
    }

    public async toggleTheme() {
        this.applyTheme(this.theme === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    public themeLabel() {
        return this.theme === 'dark' ? '화이트 모드로 전환' : '다크 모드로 전환';
    }

    public async setView(view: string) {
        if (this.loading) return;
        this.view = view === 'register' ? 'register' : 'login';
        await this.service.render();
    }

    public tabClass(view: string) {
        return this.view === view ? 'access-tab is-active' : 'access-tab';
    }

    private detectTheme() {
        try {
            const saved = localStorage.getItem(this.themeStorageKey);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch (error) { }
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    private applyTheme(theme: string) {
        this.theme = theme === 'dark' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', this.theme);
        document.documentElement.style.colorScheme = this.theme;
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', this.theme === 'dark' ? '#071321' : '#1c4efc');
        try {
            localStorage.setItem(this.themeStorageKey, this.theme);
        } catch (error) { }
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    private saveLocalSession(user: any, fallbackEmail: string = '') {
        const email = user?.email || fallbackEmail;
        localStorage.setItem('fab.auth.session', JSON.stringify({
            id: user?.id || email,
            email: email,
            name: user?.name || (email === 'admin' ? '관리자' : email),
            role: user?.role || (email === 'admin' ? 'admin' : 'user')
        }));
    }

    private activateSession(user: any, fallbackEmail: string = '') {
        const email = user?.email || fallbackEmail;
        const session = {
            id: user?.id || email,
            email: email,
            name: user?.name || (email === 'admin' ? '관리자' : email),
            role: user?.role || (email === 'admin' ? 'admin' : 'user')
        };
        this.saveLocalSession(session, email);
        this.service.auth.session = session;
        this.service.auth.status = true;
        this.service.auth.loading = true;
        this.service.auth.timestamp = new Date().getTime();
        this.service.href('/dashboard2');
    }

    public async login() {
        if (this.loading) return;
        let user = JSON.parse(JSON.stringify(this.data));
        user.email = (user.email || '').trim();
        if (!user.email) {
            await this.alert("ID를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        // user.password = this.service.auth.hash(user.password);

        this.loading = true;
        await this.service.render();
        let { code, data } = await wiz.call("login", user);
        this.loading = false;

        if (code == 200) {
            this.activateSession(data?.user, user.email);
        } else {
            await this.alert((data && data.message) || "로그인에 실패했습니다.", 'error');
            await this.service.render();
        }
    }

    public async register() {
        if (this.loading) return;
        let user = JSON.parse(JSON.stringify(this.signup));
        user.email = (user.email || '').trim();
        user.name = (user.name || '').trim();

        if (!user.email) {
            await this.alert("ID를 입력해주세요.");
            return;
        }
        if (!user.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (user.password.length < 8) {
            await this.alert("비밀번호는 8자 이상 입력해주세요.");
            return;
        }
        if (user.password !== user.passwordConfirm) {
            await this.alert("비밀번호 확인이 일치하지 않습니다.");
            return;
        }

        this.loading = true;
        await this.service.render();
        let { code, data } = await wiz.call("register", user);
        this.loading = false;

        if (code == 200) {
            this.activateSession(data?.user, user.email);
        } else {
            await this.alert((data && data.message) || "회원가입에 실패했습니다.", 'error');
            await this.service.render();
        }
    }
}

export default PageAccessComponent;